import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { initialLocation } from '../../../common/constants/runtime';
import { cleanURL } from '../../../common/url/clean-url';
import { LOG_LEVELS } from '../constants';
export var Log = /*#__PURE__*/_createClass(
/** @type {long} the unix timestamp of the log event */

/** @type {string} the log message */

/** @type {object} the object of attributes to be parsed by logging ingest into top-level properties */

/** @type {'ERROR'|'TRACE'|'DEBUG'|'INFO'|'WARN'} the log type of the log */

/**
 * @param {number} timestamp - Unix timestamp
 * @param {string} message - message string
 * @param {object} attributes - other log event attributes
 * @param {enum} level - Log level
 */
function Log(timestamp, message) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : LOG_LEVELS.INFO;

  _classCallCheck(this, Log);

  _defineProperty(this, "timestamp", void 0);

  _defineProperty(this, "message", void 0);

  _defineProperty(this, "attributes", void 0);

  _defineProperty(this, "level", void 0);

  /** @type {long} */
  this.timestamp = timestamp;
  this.message = message;
  this.attributes = _objectSpread(_objectSpread({}, attributes), {}, {
    pageUrl: cleanURL('' + initialLocation)
  });
  this.level = level.toUpperCase();
});